import { makeStyles } from '@material-ui/styles';

const CardMessageWrapper: React.FC = ({ children }) => {
    const classes = useStyles();

    return <div className={classes.cardWrapper}>{children}</div>;
};

const useStyles = makeStyles(
    theme => ({
        cardWrapper: {
            margin: 24,
            padding: 16,
            backgroundColor: theme.palette.greys[200],
            borderRadius: 16,
        },
    }),
    { classNamePrefix: CardMessageWrapper.name }
);

export default CardMessageWrapper;
